// extracted by mini-css-extract-plugin
export default {"root":"classes_root__mI6zU","main-title-container":"classes_main-title-container__78RTy","info":"classes_info__a7xxv","title":"classes_title__MFUYp"};